// 添付ファイルロード中表示
<template>
  <loading :fullscreen="fullscreen" :msg="msg" />
</template>

<style></style>

<script lang="ts">
import { defineComponent } from "vue";

import Loading from "./Loading.vue";

export default defineComponent({
  name: "loading-attachment",
  components: { Loading },
  props: {
    fullscreen: { type: Boolean, default: true },
    msg: { type: String, default: "Now Loading..." },
  },
});
</script>
